import actions from "../actions";
import { useDispatch } from "react-redux";
import { App } from "antd";

function withApp(Component) {
  function ComponentWithApp(props) {
    const app = App.useApp();
    const dispatch = useDispatch();

    dispatch(actions.antd.setAntd(app));

    return <Component {...props} app={app} />;
  }

  return ComponentWithApp;
}

export { withApp };
